import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  UpdateCsobUserDatasetChoiceDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_INFO } from "../GetCurrentCsobCompanyInfo";
import { ACTION_GET_CSOB_DATASET_COMPARISON } from "../GetCsobDatasetComparison";

import { csobHubApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_USER_DATASET_CHOICE = "UPDATE_USER_DATASET_CHOICE";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const updateUserModalViewedVersion = async (
  data: UpdateCsobUserDatasetChoiceDto,
): Promise<void> => {
  const response =
    await csobHubApi.csobHubControllerUpdateUserModalViewedVersion(data);

  return response.data;
};

export const useUpdateUserModalViewedVersion = (
  user: UserProfileDto | null,
): {
  updateUserModalViewedVersion: (data: UpdateCsobUserDatasetChoiceDto) => void;
  updateUserModalViewedVersionError: Error | null;
  updateUserModalViewedVersionEnabled: boolean;
  isPendingUpdateUserModalViewedVersion: boolean;
  isSuccessUpdateUserModalViewedVersion: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess } = useMutation({
    mutationKey: [DOMAIN_CSOB, ACTION_UPDATE_USER_DATASET_CHOICE],
    mutationFn: enabled ? updateUserModalViewedVersion : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CURRENT_COMPANY_INFO],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_DATASET_COMPARISON],
      });
    },
  });

  return {
    updateUserModalViewedVersion: mutate,
    updateUserModalViewedVersionError: error,
    updateUserModalViewedVersionEnabled: enabled,
    isPendingUpdateUserModalViewedVersion: isPending,
    isSuccessUpdateUserModalViewedVersion: isSuccess,
  };
};
